import { Injectable, inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { Firestore } from '@angular/fire/firestore';
import { collection, doc, addDoc, updateDoc, deleteDoc, query } from 'firebase/firestore';
import { collectionData } from 'rxfire/firestore';
import { Tank } from 'src/app/models/tank';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TankService {
  private firestore = inject(Firestore);
  private auth = inject(Auth);

  public userId: string | null = null;

  constructor() {
    authState(this.auth).subscribe(user => {
      this.userId = user ? user.uid : null;
    });
  }

  getTanks(userId: string): Observable<Tank[]> {
    const tanksCollectionRef = collection(this.firestore, `users/${userId}/tanks`);
    const tanksQuery = query(tanksCollectionRef);
    return collectionData(tanksQuery, { idField: 'tankId' }) as Observable<Tank[]>;
  }

  add(tank: Tank) {
    if (!this.userId) return;
    const tanksCollectionRef = collection(this.firestore, `users/${this.userId}/tanks`);
    return addDoc(tanksCollectionRef, tank);
  }

  updateTank(updatedTank: Tank) {
    if (!this.userId) return;
    const tankDocRef = doc(this.firestore, `users/${this.userId}/tanks/${updatedTank.tankId}`);
    return updateDoc(tankDocRef, { ...updatedTank });
  }

  deleteTank(tank: Tank) {
    if (!this.userId) return;
    const tankDocRef = doc(this.firestore, `users/${this.userId}/tanks/${tank.tankId}`);
    return deleteDoc(tankDocRef);
  }
}
